import { getListPermissions, getUserRolePermissions } from './getData'

const userRolePermissions = JSON.parse(localStorage.getItem('userPermissions'))

const permissions = {
  namespaced: true,
  state: {
    listPermissions: [],
    listSelectPermission: [],
    userRolePermissions: userRolePermissions || [],
  },
  mutations: {
    updateList: (state, list) => {
      state.listPermissions = list || []
      state.listSelectPermission = []
      if (list) {
        list.forEach((item) =>
          state.listSelectPermission.push({
            text: item.name,
            value: item._id,
          })
        )
      }
    },
    updateUserRolePermissionsList: (state, list) => {
      state.userRolePermissions = list || []
    },
    setInStorage: (state) => {
      localStorage.setItem(
        'userPermissions',
        JSON.stringify(state.userRolePermissions)
      )
    },
  },
  actions: {
    setInit: async ({ commit }) => {
      await getListPermissions(commit)
    },
    setInitUserPermissions: async ({ commit }) => {
      await getUserRolePermissions(commit)
      commit('setInStorage')
    },
  },
}

export default permissions
